import {Mapper} from '@s-ui/domain'

import TrackingMappersFactory from '../Mappers/factory.js'
import {UserAlertsMatchesPageTrackingValueObject} from '../ValueObjects/UserAlertsMatchesPageTrackingValueObject.js'

export class UserAlertsMatchesPageTrackingMapper extends Mapper {
  #config
  #mapper

  constructor({config, mapper}) {
    super()
    this.#config = config
    this.#mapper = mapper
  }

  static create({config}) {
    return new UserAlertsMatchesPageTrackingMapper({
      config,
      mapper: TrackingMappersFactory.fromSearchJSONToFiltersTrackingMapper({config})
    })
  }

  map({filters}) {
    const trackingFilters = filters ? this.#mapper.map({search: filters}) : {}
    return UserAlertsMatchesPageTrackingValueObject.createFromConfig({config: this.#config, filters: trackingFilters})
  }
}
